// compare-to-percent directive
//
//   <compare-to-percent base="10" compare="5" />
//
// yields
//
//   <strong class="text-success">
//     <i class="fa fa-caret-up"></i> 100%
//   </strong>

let module = angular.module('app.directives');

module.component('compareToPercent', {
  bindings: {
    base: '<',
    compare: '<',
  },
  template: `
    <span ng-if="$ctrl.base == $ctrl.compare">
      <strong class="text-success">-</strong>
    </span>
    <span ng-if="$ctrl.base != $ctrl.compare && !$ctrl.compare">
      <strong class="text-success">
        <i class="fa fa-caret-up"></i> 1000%
      </strong>
    </span>
    <span ng-if="$ctrl.compare && $ctrl.base > $ctrl.compare">
      <strong class="text-success">
        <i class="fa fa-caret-up"></i>
        {{100*($ctrl.base-$ctrl.compare)/$ctrl.compare|number:1}}%
      </strong>
    </span>
    <span ng-if="$ctrl.compare && $ctrl.base < $ctrl.compare">
      <strong class="text-danger">
        <i class="fa fa-caret-down"></i>
        {{100*($ctrl.compare-$ctrl.base)/$ctrl.compare|number:1}}%
      </strong>
    </span>
  `,
});



// WEBPACK FOOTER //
// ./app/directives/compare-to-percent.js